import request from '@/utils/request'


// 关联医院名称修改
export function updHosp(data) {
    return request({
        url: '/db/hosp-info/update',
        method: 'put',
        params: data
    })
}

// 关联医院名称删除
export function delHosp(data) {
    return request({
        url: '/db/hosp-info/delete',
        method: 'delete',
        params: data
    })
}
